import React from 'react';
import './index.scss';

function ServiceAgreement() {
  return (
    <div className="agreement-container" component-data="service-agreement">
      <div className="agreement-wrap">
        <h1 className="agreement-title">聘准准服务协议</h1>

        <section className="agreement-section">
          <h2 className="section-title">一、服务协议的接受</h2>
          <p className="section-content">
            欢迎您使用聘准准产品和服务！
            <br />
            为使用聘准准（以下简称"我们"）提供的产品和服务，请您务必审慎阅读、充分理解本《服务协议》（简称"本协议"）各条款内容，特别是免除或限制责任的相应条款，以及开通或使用服务的协议，并选择接受或不接受。
            <br />
            您一旦开始使用聘准准平台服务，即表示您认同本《服务协议》中所述内容。在我们更新本《服务协议》后，您继续使用我们的产品与/或服务，即意味着您同意本《服务协议》(含更新版本)内容。
          </p>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">二、服务说明</h2>
          <h3 className="sub-title">2.1 服务内容</h3>
          <p className="section-content">
            聘准准提供的技术服务包括创建简历、岗位收藏、职位搜索、企业搜索、简历在线投递、岗位智能推荐、面试预约、职业规划、职业测评等。具体服务内容以平台实际提供为准。
          </p>

          <h3 className="sub-title">2.2 服务的变更和中断</h3>
          <p className="section-content">
            聘准准有权根据用户及市场的需求、产品及服务类型的变化等各种因素，对现有技术服务种类、功能等进行调整。我们会提前通知用户相关变更。如因不可抗力或系统维护需要，聘准准可能中断或终止部分或全部服务，但会依法保护用户的合法权益。
          </p>

          <h3 className="sub-title">2.3 服务的限制</h3>
          <p className="section-content">
            聘准准提供的所有技术服务均为辅助性工具，不构成对求职、招聘效果的任何保证或担保。用户应自行判断信息的真实性和有效性。
          </p>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">三、用户行为规范</h2>
          <h3 className="sub-title">3.1 用户不得实施的开通行为</h3>
          <p className="section-content">非经聘准准许可，用户不得通过以下方式开通/获取本服务，否则将构成违约：</p>
          <ul className="content-list">
            <li>以营利、经营等非个人使用的目的为自己或他人开通本服务；</li>
            <li>通过任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件等任何程序、软件方式为自己或他人开通本服务；</li>
            <li>通过任何不正当手段或以违反诚实信用原则的方式为自己或他人开通/获取本服务；</li>
            <li>通过非聘准准指定的方式为自己或他人开通本服务。</li>
          </ul>

          <h3 className="sub-title">3.2 用户在使用本服务时不得出现以下情况/从事以下活动：</h3>
          <ul className="content-list">
            <li>发布、传送、传播、储存违反国家法律、危害国家安全统一、社会稳定、公序良俗、社会公德以及侮辱、诽谤、淫秽、暴力的内容；</li>
            <li>发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</li>
            <li>虚构事实、隐瞒真相以误导、欺骗他人；</li>
            <li>发表、传送、传播广告信息及垃圾信息；</li>
            <li>滥用客服功能、骚扰客服人员或平台其他工作人员；</li>
            <li>涉嫌从事其他违反法律法规、政策及公序良俗、社会公德等的行为；</li>
            <li>通过任何方式收集本服务中其他用户的用户名、电子邮件等相关信息，并以发送垃圾邮件、连锁邮件、垃圾短信、即时消息等方式干扰、骚扰其他用户；</li>
            <li>通过本服务发布包含广告、宣传、促销等内容的信息。</li>
          </ul>

          <h3 className="sub-title">3.3 用户责任</h3>
          <p className="section-content">
            用户必须为自己注册账号下的一切行为负责，包括但不限于用户所发表的任何内容以及由此产生的任何后果。用户应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的准确性、完整性或实用性的依赖而产生的风险。
          </p>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">四、个人信息收集与使用</h2>
          <h3 className="sub-title">4.1 信息收集</h3>
          <p className="section-content">
            根据合法、正当、必要、透明的原则，我们会在以下场景收集您的个人信息：
          </p>
          <ul className="content-list">
            <li><strong>注册登录：</strong>需要提供手机号码，通过短信验证码方式验证身份。</li>
            <li><strong>实名认证：</strong>需要提供真实姓名、性别、年龄、身份证号等必要信息。</li>
            <li><strong>位置信息：</strong>经您授权同意后，获取您所在的城市、地区信息，用于"查找附近职位"等功能。</li>
            <li><strong>创建简历：</strong>设置头像、填写生日、年龄、住址、期望工作地、工作经验、自我介绍、职业技能等基本信息。</li>
          </ul>

          <h3 className="sub-title">4.2 信息使用目的</h3>
          <p className="section-content">
            我们收集您的个人信息主要用于：为您提供求职招聘服务、展示合适的岗位信息、进行安全风控统计、服务推送等。我们仅收集必要的信息，且会严格依法保护您的个人信息。
          </p>

          <h3 className="sub-title">4.3 信息共享</h3>
          <p className="section-content">
            除以下情形外，未经您同意，我们不会向第三方共享您的信息：
          </p>
          <ul className="content-list">
            <li>与履行法律法规规定的义务相关的；</li>
            <li>与国家安全、国防安全直接相关的；</li>
            <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
            <li>您自行向社会公众公开的个人信息；</li>
            <li>从合法公开披露的信息中收集到您的个人信息。</li>
          </ul>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">五、Cookie和同类技术</h2>
          <p className="section-content">
            为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 cookie 的小数据文件。cookie 主要的功能是便于您使用网站产品和服务，以及帮助网站统计独立访客数量等。我们不会将 cookie 用于本协议所述目的之外的任何用途。您可根据自己的偏好管理或删除 cookie，您可以通过更改浏览器设置限制聘准准对cookie的使用。
          </p>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">六、个人信息保护</h2>
          <h3 className="sub-title">6.1 信息存储</h3>
          <p className="section-content">
            您在使用聘准准产品及服务期间，我们将依据相关法律法规的规定保存您的信息。在您注销账户或主动删除上述信息后，我们将同步删除您的个人信息。我们会将您的个人信息储存在中华人民共和国境内。
          </p>

          <h3 className="sub-title">6.2 保护措施</h3>
          <p className="section-content">
            我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如：SSL协议加密保护、HTTPS协议安全浏览方式、加密技术、受信赖的保护机制防止恶意攻击、部署访问控制机制等。
          </p>

          <h3 className="sub-title">6.3 安全事件通知</h3>
          <p className="section-content">
            若发生个人信息安全事件，我们将按照法律法规的要求，及时通过软件内部提醒、短信或电话等方式向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您的补救措施等。
          </p>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">七、您的权利</h2>
          <p className="section-content">我们保障您对自己的个人信息行使以下权利：</p>
          <ul className="content-list">
            <li><strong>访问和修改：</strong>您可以随时修改您的简历信息。</li>
            <li><strong>删除：</strong>在法律法规或与您的约定允许的情况下，您可以向我们提出删除个人信息的请求。</li>
            <li><strong>改变授权：</strong>您可以在设备本身操作系统中关闭地理位置、摄像头、麦克风权限改变同意范围或撤回您的授权。</li>
          </ul>
          <p className="section-content">
            请您理解，特定的业务功能和服务将需要您的信息才能完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。
          </p>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">八、未成年人信息保护</h2>
          <p className="section-content">
            聘准准非常重视对未成年人信息的保护。基于我们的产品、网站和服务的性质，我们仅面向成年人提供服务（原则上18周岁以上为成年人，16周岁以上且以自己的劳动收入为主要生活来源的我们亦视为具有服务使用资格）。
          </p>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">九、知识产权</h2>
          <p className="section-content">
            聘准准平台上的所有内容（包括但不限于文字、图片、音频、视频、软件、程序、页面设计、数据等）的知识产权归聘准准或相关权利人所有。用户在使用本服务时产生的内容（如简历信息、发布的内容等）的知识产权归用户或其合法权利人所有，但用户授予聘准准在全球范围内免费、非独占性的使用许可，用于提供服务和改进我们的产品。
          </p>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">十、违约责任</h2>
          <p className="section-content">
            如用户违反法律法规或本协议任何一项约定的，聘准准有权在不事先通知用户的情况下立即终止其部分或所有技术服务的使用，同时，有权视违约情形严重程度，暂时或永久取消其在本平台享有的账号使用权限。用户有违反本协议的任何行为，导致任何第三方损害的，用户应当独立承担责任；聘准准因此遭受损失的，有权向用户追偿。
          </p>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">十一、协议的更新</h2>
          <p className="section-content">
            我们可能适时修订本《服务协议》内容。如该等变更会导致您在本《服务协议》项下权利的实质变化，若您不同意该等变更应停止使用聘准准平台产品和服务。若您继续使用我们的产品或服务，即表示您同意受修订后的本《服务协议》的约束。若涉及重大、实质性变更，我们会依据具体情况，以弹窗提示等显著的方式通知您。
          </p>
        </section>

        <section className="agreement-section">
          <h2 className="section-title">十二、争议解决</h2>
          <p className="section-content">
            本《服务协议》与《个人信息保护政策》共同构成您使用聘准准服务的基本协议文件。本《服务协议》适用中华人民共和国现行法律法规。与本《服务协议》相关的争议，如果您对我们的回复或解决方案不满意，需要通过法律途径解决的，您在此同意将该争议提交至杭州市仲裁委员会，其仲裁裁决是终局的。
          </p>
        </section>
      </div>
    </div>
  );
}

export default ServiceAgreement;